import './src/styles/global.css'

// !!set bownow id here!!
const BowNowId = {
  ts: 'UTC_2e40f188133d5e94db53',
  // cs id is now managed in contact.js
}

// BownowContext and wrapRootElement are no longer needed for the form

//bownow form script
const onRouteUpdate = () => {
  const scriptTs = `https://contents.bownow.jp/js/${BowNowId.ts}/trace.js`;

  // Check if scripts already exist to avoid redundant injection
  const existingTs = document.querySelector(`script[src="${scriptTs}"]`);

  if (!existingTs) {
    const _bownow_ts = document.createElement('script');
    _bownow_ts.charset = 'utf-8';
    _bownow_ts.src = scriptTs;
    _bownow_ts.async = true;
    document.getElementsByTagName('head')[0].appendChild(_bownow_ts);
  }

  // The logic for scriptCs is removed as it's now handled in the Contact component.
};

export { onRouteUpdate };
